import React, { useCallback, useState } from 'react';
import { NavMenu } from '@shopify/app-bridge-react';
import { Layout1 } from './components/Layout1';
import { AppRoutes } from './components/routing/AppRoutes';
import { useAppAuth, useFeatureScopes, useAppUpdate } from './hooks';
import { useSSE } from './components/Hooks/useSSE';
import { redirectToCharge, deleteCharge, redirectToAppUpdate } from './utils/chargeHelpers';

/**
 * Main App Component - Optimized version
 * Manages app authentication, feature scopes, SSE connections, and routing
 */
export function App() {
  // Custom hooks for state management
  const { 
    appInstalled, 
    trialDays, 
    planDownGrade, 
    chargeAlert, 
    currentPlan,
    planLoading,
    setTrialDays,
    setPlanDowngrade,
    setChargeAlert,
    storeUrl,
    refreshPlan
  } = useAppAuth();

  const scopes = useFeatureScopes(storeUrl);
  const showAppUpdate = useAppUpdate(storeUrl);
  
  // UI state
  const [toast, setToast] = useState(false);
  const [btnLoad, setBtnLoad] = useState(false);
  const [chargeBtnLoad, setChargeBtnLoad] = useState(false);
  
  const toggleToast = useCallback(() => setToast((toast) => !toast), []);

  // SSE connection with custom hook
  const { eventSource } = useSSE(storeUrl, {
    autoConnect: true,
    debug: false,
    onError: (error) => console.error('SSE Error:', error),
    onConnect: () => console.log('SSE Connected'),
  });

  // Handler functions
  const handleActivateCharge = useCallback(() => {
    const currentParams = new URLSearchParams(window.location.search);
    const storeUrlParam = currentParams.get('storeUrl') || storeUrl;
    const pricingUrl = `/plans?storeUrl=${encodeURIComponent(storeUrlParam)}`;
    window.top.location.href = window.location.origin + pricingUrl;
  }, [storeUrl]);

  const handleDeleteCharge = useCallback(() => {
    deleteCharge(storeUrl, setBtnLoad, setToast, setPlanDowngrade);
  }, [storeUrl, setPlanDowngrade]);

  const handleAllowScope = useCallback(() => {
    redirectToAppUpdate(window.location.pathname, storeUrl);
  }, [storeUrl]);

  const handleDismissTrial = useCallback(() => {
    setTrialDays(0);
  }, [setTrialDays]);

  console.log("app installed=", appInstalled);

  return (
    <>
      <NavMenu>
        <a href="/products">Products</a>
        <a href="/collections">Collections</a>
        <a href="/customers">Customers</a>
        <a href="/pages">Pages</a>
        <a href="/metaobjects">Metaobjects</a>
        <a href="/definitions">Definitions</a>
        <a href="/translations">Translations</a>
        {/* <a href="/orders">Orders</a> */}
        <a href="/menu">Menu</a>
        <a href="/plans">Plans</a>
        <a href="/privacy">Privacy</a>
      </NavMenu>
      
      <Layout1>
        <AppRoutes
          trialDays={trialDays}
          planDownGrade={planDownGrade}
          chargeAlert={chargeAlert}
          btnLoad={btnLoad}
          chargeBtnLoad={chargeBtnLoad}
          currentPlan={currentPlan}
          planLoading={planLoading}
          scopes={scopes}
          eventSource={eventSource}
          showAppUpdate={showAppUpdate}
          toast={toast}
          toggleToast={toggleToast}
          onActivateCharge={handleActivateCharge}
          onDowngradePlan={handleDeleteCharge}
          onDismissTrial={handleDismissTrial}
          onAllowScope={handleAllowScope}
          redirectToCharge={(storeUrl, planTier) => redirectToCharge(storeUrl, planTier, setChargeBtnLoad)}
          setChargeAlert={setChargeAlert}
          refreshPlan={refreshPlan}
        />
      </Layout1>
    </>
  );
}
